import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { getAuthUserAction } from "../Store/Actions/AuthActions";
import LoaderScreen from "../Pages/LoaderScreen";

const AdminRoute = ({ component: Component }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const { user, isAuthenticated } = useSelector((state) => state.auth);

  const loginCheck = () => {
    getAuthUserAction(dispatch)
      .then((res) => {
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loginCheck();
  }, []);

  if (!loading && isAuthenticated && user.type === "admin") {
    return <Component />;
  } else if (!loading && isAuthenticated && user.type !== "admin") {
    return <Navigate to="/user" />;
  } else if (!loading && !isAuthenticated) {
    return <Navigate to="/login" />;
  } else {
    return <LoaderScreen />;
  }
};

export default AdminRoute;
